// Temporary kill switch for the "Custom prompt emails" feature. While false, the overview link
// is hidden and the /overview/custom-prompts routes are not registered. Flip to true to re-enable.
export const CUSTOM_PROMPTS_ENABLED = false;
